import styled from 'react-emotion';

const SearchTerm = styled('span')`
  color: ${({ theme }) => theme.colors.black};
  display: block;
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: 26px;
  font-weight: bold;
  margin-top: 0.5rem;
  text-align: center;
`;

export default SearchTerm;
